module.exports = __webpack_public_path__ + "img/chord-label-G.5ea4417b.png";